<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/chongqing/cq.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器重庆工厂
                </div>
                <div class="manufacture-t2">
                    位于重庆永川区，占地面积113亩，2021年6月正式投产，主要生产2.0L、3.0L汽柴油机、2.4L柴油机；<br />
                    公司采用国际进口先进自动化设备，秉持柔性化、自动化、信息化的生产理念，实现标准化生产，整体设计年产能50万台；<br />
                    凭借高效的生产能力，公司深耕汽车核心零部件领域，为汽车产业绿色转型与智能化升级提供有力支撑。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                机加线体
                            </div>
                            <div class="destils">
                                精益化布局，具备2.0、2.4排量柴油发动机核心零部件生产能力<br />
                                生产线主要采用德、日系等国际一流品牌设备，云端部署MES追溯、防错智能信息系统，整线分布技研桁架、FANUC机械手，实现精准自动上下料
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/chongqing/cq1-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>

        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/chongqing/cq2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                装试线体
                            </div>
                            <div class="destils">
                                柔性化设计，具备2.0柴/汽油、3.0柴/汽油、2.4柴油多种发动机整机生产能力<br />
                                生产线由业内顶尖智能装备公司提供解决方案，依托MES生产管理系统、全自动工业机器人、高精度拧紧及视觉等大量业内领先技术装备，实现多样化、柔性化、高品质生产
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器重庆工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/chongqing.html'
};

import { createApp } from 'vue';
import App from './chongqing.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./chongqing.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
